import { useContext, useEffect, useMemo, useState } from "react";
import { showNotesPrompt } from "../../components/NotesPromptDialog/notesPrompt";
import AddPaymentWidget from "./../../components/AddPaymentWidget";

import OrdersListWidget from "../../components/AddPaymentWidget/OrdersListWidget";
import {
    useCrateOrderInvoice,
    useOrderInvoiceData,
} from "../../shared/hooks/useInvoicesData";

import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import { pdfjs } from "react-pdf";
import { AppContext } from "../../AppContext";
import { useUpdateDoctypeData } from "../../shared/hooks/useDocTypesData";
import { useAddons } from "../../shared/hooks/useItemsData";
import {
    useDefferOrderItem,
    useDivideOrderItemsData,
    useOrderItemOnHouse,
} from "../../shared/hooks/useTableOrderItemsData";
import { useFetchGetInvoiceData } from "../../shared/hooks/useTableOrdersData";
import { usePrintOrder } from "../../shared/hooks/useTablesData";
import { PosContext } from "../../shared/PosContext";
import { isJsonString } from "../../utils/floorUtils";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function WidgetsPage({
    mode,
    handleNext,
    backCallback,
    table,
    order,
    handleInvoiceClosed,
    isTakeaway,
}) {
    const {
        setLoadingTable,
        selectedFloor,
        restaurantSettings,
        elevatedPrivileges,
    } = useContext(AppContext);

    const { refetchTablesData } = useContext(PosContext);
    const { data: addons } = useAddons();

    const [discount, setDiscount] = useState(0);
    const [tip, setTip] = useState(0);
    const [entryItems, setEntryItems] = useState([]);
    const [invoice, setInvoice] = useState(null);
    const [isPaymentLoading, setPaymentLoading] = useState(false);
    const [payingAll, setPayingAll] = useState(false);

    const [finalPayload, setFinalPayload] = useState();
    const [amountAfterDiscount, setAmountAfterDiscount] = useState("00.00");

    const [paymentType, setPaymentType] = useState(null);

    const [presetDiscount, setPresetDiscount] = useState(null);
    const [presetDiscountAmount, setPresetDiscountAmount] = useState(null);
    const [orderOnHouse, setOrderOnHouse] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(false);

    const [amountChanged, setAmountChanged] = useState(false);

    const [fixedDiscountAmount, setFixedDiscountAmount] = useState(0);
    const [discountPercentage, setDiscountPercentage] = useState(0);

    const [paymentData, setPaymentData] = useState({});

    const [orderEntryItems, setOrderEntryItems] = useState({});

    const { data: model, isLoading: isInvoiceLoading } = useOrderInvoiceData(
        order ? order.name : Object.values(table.orders)[0].name
    );

    const updateTableOrder = useUpdateDoctypeData();
    const printOrder = usePrintOrder();
    const { mutate: fetchGetInvoiceData, isLoading: isInvoiceDataLoading } =
        useFetchGetInvoiceData();

    const entryItemsPayload = useMemo(() => {
        const itemsPayload = {};
        entryItems?.forEach((item) => {
            itemsPayload[item.identifier] = {
                identifier: item.identifier,
                item_code: item.item_code,
                qty: item.qty,
                rate: item.rate,
                price_list_rate: item.rate,
                notes: item.notes,
                addons: item.addons,
                ///////////
                has_serial_no: 0,
                serial_no: 0,
                has_batch_no: 0,
                batch_no: 0,
            };
        });
        return itemsPayload;
    }, [entryItems]);

    const roundToNearest5WithMaxCap = (num) => {
        if (num > 20) {
            return 20;
        }
        return Math.round(num / 5) * 5;
    };

    useEffect(() => {
        if (order) {
            if (order.discount) {
                const totalBeforeDiscount = order.discount + order.amount;
                const _discount = roundToNearest5WithMaxCap(
                    (1 - order.amount / totalBeforeDiscount) * 100
                );
                setPresetDiscount(_discount);
                setPresetDiscountAmount(order.discount); // Store the actual discount amount
                setDiscount(_discount);
                setPaymentData({
                    discount: _discount,
                    tip: 0,
                    amount: totalBeforeDiscount,
                    amountAfterDiscount: order.amount,
                    mode_of_payment: paymentType,
                    orderAmount: order.amount,
                    entryItems: [],
                });
            } else {
                setPresetDiscount(null);
                setPresetDiscountAmount(null);
                setPaymentData({
                    discount: 0,
                    tip: 0,
                    amount: order.amount,
                    amountAfterDiscount: order.amount,
                    mode_of_payment: paymentType,
                    orderAmount: order.amount,
                    entryItems: [],
                });
            }
        }
    }, [order]);

    const callHandleNext = (totalPayload) => {
        let invoiceEntriesPayload = {};
        if (totalPayload.payingAll) {
            invoiceEntriesPayload = entryItemsPayload;
            setPayingAll(true);
        } else {
            Object.entries(totalPayload.items).forEach(([key, value]) => {
                invoiceEntriesPayload[key] = {
                    ...entryItemsPayload[key],
                    ...value,
                };
            });
            setPayingAll(false);
        }

        setOrderEntryItems(invoiceEntriesPayload);

        const _addonsEntries = {};

        Object.values(invoiceEntriesPayload).forEach((value) => {
            const entryAddons = isJsonString(value.addons)
                ? JSON.parse(value.addons)
                : value.addons;
            entryAddons.forEach((addon) => {
                _addonsEntries[addon.identifier] = {
                    ...addon,
                    batch_no: 0,
                    addons: "[]",
                    has_batch_no: 0,
                    has_serial_no: 0,
                    serial_no: 0,
                    price_list_rate: addon.rate,
                };
            });
        });

        setInvoice(null);
        fetchGetInvoiceData(
            {
                orderId: order
                    ? order.name
                    : Object.values(table.orders)[0].name,
                entry_items: { ...invoiceEntriesPayload },
                // entry_items: { ...invoiceEntriesPayload, ..._addonsEntries },
                discount_percentage: discount,
            },
            {
                onSuccess: (data) => {
                    setInvoice(data);
                    handleNext(finalPayload);
                },
            }
        );
    };

    useEffect(() => {
        const { amount } = paymentData;
        const newAmount = amount - amount * (discount / 100);
        setAmountAfterDiscount("" + Math.ceil(newAmount));
    }, [discount]);

    const handlePropertyChange = (event, propertyName, newValue) => {
        if (!newValue) newValue = event?.target.value;
        if (propertyName === "amount") {
            setAmountChanged(true);
        }
        setPaymentData((prevData) => ({
            ...prevData,
            [propertyName]: newValue,
        }));
    };

    const { mutate: createInvoiceMutation, isLoading: isCreatingInvoice } =
        useCrateOrderInvoice();
    const divideOrderItemsDataMutation = useDivideOrderItemsData();
    const onHouseOrderItemMutation = useOrderItemOnHouse();
    const defferedOrderItemMutation = useDefferOrderItem();

    useMemo(() => {
        if (model) {
            const { doc } = model;
            const { entry_items } = doc;

            const filteredEntryItems = _.differenceWith(
                entry_items,
                addons.filter((item) => item.item_type === "Addons"),
                (entryItem, tempItem) => {
                    return (
                        _.toLower(entryItem.item_code) ===
                        _.toLower(tempItem.item_code)
                    );
                }
            );
            setEntryItems(filteredEntryItems);
        }
    }, [model]);

    // CREATE INVOICE
    const handleInvoice = (
        orderId,
        payload,
        discountInfo = null,
        requiresElevatedPrivileges = false
    ) => {
        let floor = selectedFloor?.name; //TODO NEEDS TESTING CHANGE TO PosContext
        let floorName = "";
        if (floor) {
            floorName = floor.name;
        }
        if (isCreatingInvoice) return;
        createInvoiceMutation(
            {
                orderId: orderId,
                formData: payload,
                floorName: floorName,
                elevatedPrivileges: requiresElevatedPrivileges,
                elevatedText: requiresElevatedPrivileges
                    ? "Apply discount to order"
                    : "",
            },
            {
                onSuccess: (data, variables, context) => {
                    // refetchFloorData();
                    const { invoice_name, status } = data.data.message;

                    // Update Table Order discount field after successful invoice creation
                    if (
                        discountInfo &&
                        discountInfo.discountType === "fixed" &&
                        discountInfo.fixedDiscountAmount > 0
                    ) {
                        // Update Table Order with fixed discount amount
                        updateTableOrder.mutate({
                            doctype: "Table Order",
                            name: orderId,
                            formData: JSON.stringify({
                                discount: discountInfo.fixedDiscountAmount,
                            }),
                        });
                    } else if (discount > 0) {
                        // Update Table Order with percentage discount amount
                        // Calculate discount amount from percentage (if needed)
                        if (model && model.doc && model.doc.entry_items) {
                            const originalTotal = model.doc.entry_items.reduce(
                                (total, item) => {
                                    return total + item.rate * item.qty;
                                },
                                0
                            );
                            const discountAmount =
                                (originalTotal * discount) / 100;
                            updateTableOrder.mutate({
                                doctype: "Table Order",
                                name: orderId,
                                formData: JSON.stringify({
                                    discount: discountAmount,
                                }),
                            });
                        }
                    }

                    const settingsInvoicePrinter =
                        restaurantSettings?.docs[0]?.invoice_printer;
                    if (invoice_name) {
                        if (
                            !settingsInvoicePrinter &&
                            restaurantSettings?.docs[0]?.dont_print_invoices != 1
                        ) {
                            const printUrl = `/api/method/frappe.utils.print_format.download_pdf?doctype=POS%20Invoice&name=${invoice_name}&format=POS&no_letterhead=0&settings=%7B%7D&_lang=en`;

                            // Create a hidden iframe to handle the PDF printing
                            const iframe = document.createElement("iframe");
                            iframe.style.display = "none";
                            iframe.src = printUrl;
                            document.body.appendChild(iframe);

                            // Wait for the iframe to load and then print
                            iframe.onload = () => {
                                try {
                                    iframe.contentWindow.print();
                                } catch (error) {
                                    console.error(
                                        "Error printing invoice:",
                                        error
                                    );
                                }
                                // Clean up the iframe after printing
                                // setTimeout(() => {
                                // document.body.removeChild(iframe);
                                // }, 1000);
                            };
                        }
                        if (handleInvoiceClosed) handleInvoiceClosed();
                    }
                },
                onError: (_err, _newTodo, context) => {
                    // Handle the error here
                    console.error("Error creating order invoice:", _err);
                    const { _server_messages } = _err;
                    if (_server_messages) {
                    }
                },
            }
        );
    };

    // HERE
    // Print Table Order function (similar to PrintOrderModal)
    const printTableOrder = (orderId) => {
        const settingsInvoicePrinter =
            restaurantSettings?.docs[0]?.invoice_printer;

        if (!settingsInvoicePrinter) {
            // Print using iframe (browser printing)
            const printUrl = `/api/method/frappe.utils.print_format.download_pdf?doctype=Table%20Order&name=${orderId}&format=Order%20Account%20Test&no_letterhead=0&settings=%7B%7D&_lang=en`;

            // Create a hidden iframe to handle the PDF printing
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.src = printUrl;
            document.body.appendChild(iframe);

            // Wait for the iframe to load and then print
            iframe.onload = () => {
                try {
                    iframe.contentWindow.print();
                    // Mark order as printed
                    updateTableOrder.mutate({
                        doctype: "Table Order",
                        name: orderId,
                        formData: JSON.stringify({ invoice_printed: 1 }),
                    });
                } catch (error) {
                    console.error("Error printing order:", error);
                }
                // Clean up the iframe after printing
                // setTimeout(() => {
                //     document.body.removeChild(iframe);
                // }, 1000);
            };
        } else {
            // Print using hardware printer
            printOrder.mutate(
                {
                    orderId: orderId,
                    doctype: "Table Order",
                    printFormat: "Order Account Test",
                },
                {
                    onSuccess: (data) => {
                        console.log("Order printed successfully");
                        // Mark order as printed
                        updateTableOrder.mutate({
                            doctype: "Table Order",
                            name: orderId,
                            formData: JSON.stringify({ invoice_printed: 1 }),
                        });
                    },
                    onError: (e) => {
                        console.log("Error printing order:", e);
                    },
                }
            );
        }
    };

    const putOrderOnHouse = async () => {
        try {
            // Show notes prompt dialog and wait for user input
            const notes = await showNotesPrompt({
                title: "House Order Notes",
                message:
                    "Please enter any notes for this house order (optional):",
                placeholder: "Enter notes for house order...",
            });

            if (!notes) {
                setPaymentLoading(false);
                enqueueSnackbar("Notes are required", {
                    variant: "error",
                });
                return;
            }

            // User confirmed, proceed with the mutation
            const orderId = model.doc.name;
            onHouseOrderItemMutation.mutate(
                {
                    orderId: orderId,
                    notes: notes || "", // Pass notes, default to empty string if null/undefined
                    elevatedPrivileges: elevatedPrivileges,
                    elevatedText: "Put order on house",
                },
                {
                    onSuccess: (data) => {
                        refetchTablesData();
                        setPaymentLoading(false);
                        // Print the table order
                        printTableOrder(orderId);
                        if (handleInvoiceClosed) handleInvoiceClosed();
                    },
                    onError: (err) => {
                        setPaymentLoading(false);
                    },
                    onSettled: (data, error, variables, context) => {
                        setPaymentLoading(false);
                    },
                }
            );
        } catch (error) {
            // User cancelled the dialog - stop execution and reset loading state
            console.log("House order cancelled by user");
            setPaymentLoading(false);
            return; // Explicitly return to make cancellation handling clear
        } finally {
            setPaymentLoading(false);
        }
    };

    const putOrderOnCustomer = () => {
        const orderId = model.doc.name;
        defferedOrderItemMutation.mutate(
            {
                orderId: orderId,
                customer: selectedCustomer,
                discount_percentage: discount,
                elevatedPrivileges: elevatedPrivileges,
                elevatedText: "Defer order",
            },
            {
                onSuccess: (data) => {
                    refetchTablesData();
                    setPaymentLoading(false);
                    setPaymentLoading(false);
                    printTableOrder(orderId);
                    if (handleInvoiceClosed) handleInvoiceClosed();
                },
                onError: (err) => {
                    setPaymentLoading(false);
                    console.log(err);
                },
                onSettled: (data, error, variables, context) => {
                    setPaymentLoading(false);
                },
            }
        );
    };

    const paymentConfirmed = (modeOfPayment, discountInfo = null) => {
        setPaymentLoading(true);

        if (orderOnHouse) {
            putOrderOnHouse();
            return;
        }

        if (selectedCustomer) {
            putOrderOnCustomer();
            return;
        }

        // Check if discount operation requires elevated privileges
        const hasDiscount =
            invoice.discount_amount > 0 ||
            fixedDiscountAmount > 0 ||
            discountPercentage > 0;
        const requiresElevatedPrivileges = hasDiscount && elevatedPrivileges;

        // Handle the new modeOfPayment object from AddPaymentWidget
        let cashItem = {};
        if (modeOfPayment && Object.keys(modeOfPayment).length > 0) {
            // Use the new payment mode data
            cashItem = modeOfPayment;
        } else {
            // Fallback to old logic for backward compatibility
            cashItem = { Cash: Number(paymentData.amount) };

            if (paymentType === "Credit Card") {
                cashItem = { "Credit Card": Number(paymentData.amount) };
            }
        }

        if (!invoice || !order) return;

        const customer = invoice.customer;
        const orderId = order.name;
        const dinners = order.dinners || 1; //model.doc.dinners ?? 1;

        // Prepare discount data for Table Order API (matches backend make_invoice method signature)
        let tableOrderDiscountData = {
            discount_amount: invoice.discount_amount || 0,
            discount_percentage: invoice.additional_discount_percentage || 0,
        };
        if (invoice.discount_amount > 0) {
        } else if (fixedDiscountAmount > 0) {
            tableOrderDiscountData = {
                discount_amount: fixedDiscountAmount,
            };
        } else if (discountPercentage > 0) {
            tableOrderDiscountData = {
                discount_percentage: discountPercentage,
            };
        }

        const payload = {
            mode_of_payment: cashItem,
            customer: customer,
            dinners: dinners,
            ...tableOrderDiscountData,
        };

        // TODO: HERE
        if (!payingAll) {
            let invoiceEntriesPayload = {};

            Object.entries(orderEntryItems).forEach(([key, value]) => {
                invoiceEntriesPayload[key] = {
                    ...value,
                };
            });

            const dividePayload = {
                client: "obj_3a5d-bf-457-825-0c237",
                items: invoiceEntriesPayload,
            };

            divideOrderItemsDataMutation.mutate(
                {
                    orderId: order.name,
                    divisionPayload: dividePayload,
                },
                {
                    onSuccess: (data) => {
                        refetchTablesData();
                        setPaymentLoading(false);
                        const { message } = data;
                        const {
                            name,
                            entry_items: orderElements,
                            customer,
                        } = message;

                        if (orderElements && orderElements.length > 0 && name) {
                            let invoiceTotalAmount = 0;
                            orderElements.forEach((entry_item) => {
                                invoiceTotalAmount +=
                                    entry_item.qty * entry_item.rate;
                            });

                            // Handle mixed payments for divided orders too
                            let invoiceCashItem = {};
                            if (
                                modeOfPayment &&
                                Object.keys(modeOfPayment).length > 0
                            ) {
                                // Proportionally distribute the payment methods based on invoice amount
                                const totalPaid = Object.values(
                                    modeOfPayment
                                ).reduce((sum, amount) => sum + amount, 0);
                                const ratio = invoiceTotalAmount / totalPaid;

                                Object.entries(modeOfPayment).forEach(
                                    ([method, amount]) => {
                                        invoiceCashItem[method] = Number(
                                            (amount * ratio).toFixed(2)
                                        );
                                    }
                                );
                            } else {
                                // Fallback to old logic
                                invoiceCashItem = {
                                    Cash: Number(invoiceTotalAmount),
                                };

                                if (paymentType === "Credit Card") {
                                    invoiceCashItem = {
                                        "Credit Card":
                                            Number(invoiceTotalAmount),
                                    };
                                }
                            }

                            // Apply the same discount logic for POS Invoice
                            let invoiceDiscountData = {
                                discount_amount: invoice.discount_amount || 0,
                                discount_percentage:
                                    invoice.additional_discount_percentage || 0,
                            };

                            if (fixedDiscountAmount > 0) {
                                invoiceDiscountData = {
                                    discount_amount: fixedDiscountAmount,
                                };
                            }

                            if (discountPercentage > 0) {
                                invoiceDiscountData = {
                                    discount_percentage: discountPercentage,
                                };
                            }

                            const invoicePayload = {
                                mode_of_payment: invoiceCashItem,
                                customer: customer,
                                dinners: 1,
                                ...invoiceDiscountData,
                            };

                            handleInvoice(
                                name,
                                invoicePayload,
                                discountInfo,
                                requiresElevatedPrivileges
                            );
                        }
                    },
                }
            );
        } else {
            setPaymentLoading(false);
            handleInvoice(
                orderId,
                payload,
                discountInfo,
                requiresElevatedPrivileges
            );
        }
    };

    const handleBackCallback = () => {
        setAmountChanged(false);
        setLoadingTable("");
        setAmountChanged(false);
        backCallback?.();
        // if (handleInvoiceClosed) handleInvoiceClosed();
    };

    return (
        <>
            {mode ? (
                <AddPaymentWidget
                    selectedTip={tip}
                    onUpdateTip={(e) => setTip(e)}
                    onUpdateDiscount={(e) => {
                        setDiscount(e);
                    }}
                    invoice={invoice}
                    presetDiscount={presetDiscount}
                    presetDiscountAmount={presetDiscountAmount}
                    selectedDiscount={discount}
                    onConfirm={paymentConfirmed}
                    isLoading={isPaymentLoading}
                    handleNext={handleNext}
                    orderAmount={paymentData.orderAmount}
                    order={order}
                    amountAfterDiscount={amountAfterDiscount}
                    isCreatingInvoice={isCreatingInvoice}
                    handlePropertyChange={handlePropertyChange}
                    isNew={!amountChanged}
                    payingAll={payingAll}
                    backCallback={handleBackCallback}
                    paymentType={paymentType}
                    setPaymentType={setPaymentType}
                    orderOnHouse={orderOnHouse}
                    setOrderOnHouse={setOrderOnHouse}
                    setSelectedCustomer={setSelectedCustomer}
                    selectedCustomer={selectedCustomer}
                    isTakeaway={isTakeaway}
                    payingAll={payingAll}
                    isNew={!amountChanged}
                    fixedDiscountAmount={fixedDiscountAmount}
                    setFixedDiscountAmount={setFixedDiscountAmount}
                    discountPercentage={discountPercentage}
                    setDiscountPercentage={setDiscountPercentage}
                />
            ) : (
                <OrdersListWidget
                    entryItems={entryItems}
                    handleNext={callHandleNext}
                    loading={isInvoiceDataLoading}
                    backCallback={handleBackCallback}
                    isInvoiceLoading={isInvoiceLoading}
                    table={table}
                />
            )}
        </>
    );
}
